import { render } from "./HorizontalCarousel.vue?vue&type=template&id=0c57f9d6&scoped=true"
import script from "./HorizontalCarousel.vue?vue&type=script&lang=js"
export * from "./HorizontalCarousel.vue?vue&type=script&lang=js"

import "./HorizontalCarousel.vue?vue&type=style&index=0&id=0c57f9d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c57f9d6"

export default script